import { useState, useEffect } from 'react';
import adminService from '../../../services/adminService';
import './AdminInvitationCodes.css';

const AdminInvitationCodes = () => {
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [newCodeData, setNewCodeData] = useState({ maxUsers: 10, maxTimelinesPerUser: 5 });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const fetchCodes = async () => {
    try {
      setLoading(true);
      setError('');
      const data = await adminService.getInvitationCodes();
      setCodes(data);
    } catch (err) {
      setError('Davet kodları yüklenemedi. ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCodes();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      setError('');
      await adminService.createInvitationCode(newCodeData);
      setShowForm(false);
      setNewCodeData({ maxUsers: 10, maxTimelinesPerUser: 5 });
      fetchCodes();
    } catch (err) {
      setError('Kod oluşturulamadı. ' + (err.response?.data?.message || err.message));
    }
  };

  const handleDelete = async (codeId) => {
    if (window.confirm('Bu davet kodunu silmek istediğinizden emin misiniz?')) {
      try {
        await adminService.deleteInvitationCode(codeId);
        fetchCodes();
      } catch (err) {
        setError('Kod silinemedi. ' + (err.response?.data?.message || err.message));
      }
    }
  };

  const totalPages = Math.ceil(codes.length / itemsPerPage);
  const paginatedCodes = codes.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  if (loading) {
    return <div className="admin-codes-loading">Yükleniyor...</div>;
  }

  return (
    <div className="admin-codes">
      {error && <div className="admin-codes-error">{error}</div>}

      <div className="admin-codes-card">
        <div className="admin-codes-header">
          <h3>Davet Kodları ({codes.length})</h3>
          <button className="admin-codes-create-btn" onClick={() => setShowForm(true)}>
            + Yeni Kod Oluştur
          </button>
        </div>

        {showForm && (
          <form className="admin-codes-form" onSubmit={handleCreate}>
            <h4>Yeni Davet Kodu</h4>
            <div className="admin-codes-form-grid">
              <div className="admin-codes-form-group">
                <label>Maksimum Kullanıcı</label>
                <input
                  type="number"
                  value={newCodeData.maxUsers}
                  onChange={(e) => setNewCodeData({ ...newCodeData, maxUsers: parseInt(e.target.value) })}
                  min="1"
                />
              </div>
              <div className="admin-codes-form-group">
                <label>Kullanıcı Başına Çizelge</label>
                <input
                  type="number"
                  value={newCodeData.maxTimelinesPerUser}
                  onChange={(e) => setNewCodeData({ ...newCodeData, maxTimelinesPerUser: parseInt(e.target.value) })}
                  min="1"
                />
              </div>
              <div className="admin-codes-form-actions">
                <button type="submit" className="admin-codes-form-save">Kaydet</button>
                <button type="button" className="admin-codes-form-cancel" onClick={() => setShowForm(false)}>İptal</button>
              </div>
            </div>
          </form>
        )}

        <div style={{ overflowX: 'auto' }}>
          <table className="admin-codes-table">
            <thead>
              <tr>
                <th>Kod</th>
                <th>Kullanım (Kayıtlı / Maks)</th>
                <th>Çizelge / Kullanıcı</th>
                <th>Oluşturan</th>
                <th>Durum</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {paginatedCodes.map((code) => (
                <tr key={code._id}>
                  <td><span className="admin-codes-code">{code.code}</span></td>
                  <td>{code.usersRegistered} / {code.maxUsers}</td>
                  <td>{code.maxTimelinesPerUser}</td>
                  <td>{code.createdBy?.username || 'N/A'}</td>
                  <td>
                    <span className={`admin-codes-status ${code.isActive ? 'active' : 'inactive'}`}>
                      {code.isActive ? 'Etkin' : 'Pasif'}
                    </span>
                  </td>
                  <td>
                    <button className="admin-codes-delete-btn" onClick={() => handleDelete(code._id)}>
                      Sil
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="admin-codes-pagination">
            <button
              onClick={() => setCurrentPage((p) => p - 1)}
              disabled={currentPage === 1}
            >
              Önceki
            </button>
            <span>Sayfa {currentPage} / {totalPages}</span>
            <button
              onClick={() => setCurrentPage((p) => p + 1)}
              disabled={currentPage === totalPages}
            >
              Sonraki
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminInvitationCodes;
